import {mapActions, mapGetters, mapState} from 'vuex';
import _ from 'lodash';
import QtyInput from "../vue_components/QtyInput";
import store from '../store';
import {displayMessage} from "../helper";

const cartItemListMixin = {
    store,
    components: {
        QtyInput
    },
    data: {
        baseUrl: window.baseUrl,
        localCartItems: []
    },
    computed: {
        ...mapState({
            sessionOrder: state => state.sessionOrder.sessionOrder,
            isLoading: state => state.isLoading
        }),
        ...mapGetters('sessionOrder', [
            'cartItems',
            'products',
            'wines',
            'addOns'
        ]),
    },
    watch: {
        cartItems(newValue) {
            this.localCartItems = JSON.parse(JSON.stringify(newValue));
        }
    },
    methods: {
        isAnyAddOnsInItem(item) {
            return item.selected_add_ons.length > 0
        },
        isAnyWinesInItem(item) {
            return item.selected_wines.filter(selected_wine => this.wines[selected_wine.wine_group_id][selected_wine.wine_id].list_order !== 1).length > 0
        },
        parsePrice(price, fixedPoint) {
            price = parseFloat(price);
            return isNaN(price) ? parseFloat(0).toFixed(fixedPoint) : price.toFixed(fixedPoint);
        },
        ...mapActions({
            'removeOrderItemByCombinationKey': 'sessionOrder/removeOrderItemByCombinationKey',
            'updateOrderItemQty': 'sessionOrder/updateOrderItemQty',
            'updateAddOnQty': 'sessionOrder/updateAddOnQty'
        }),
        /**
         * remove cart item button on click handler
         * @param combination_key
         */
        removeCartItemBtnOnClick(combination_key) {
            window.popups.removeItemWarningPopup.popup.find('.btn-confirm').off('click').on('click', () => {
                this.removeOrderItemByCombinationKey({combination_key});
                window.popups.removeItemWarningPopup.closePopup();
            })
            window.popups.removeItemWarningPopup.openPopup();
        },
        cartItemQtyOnChange: _.debounce(function(qty) {
            this.localCartItems.forEach((localCartItem) => {
                const {combination_key, qty} = localCartItem;
                const item = this.cartItems.find(cartItem => cartItem.combination_key === combination_key);
                if(item && item.qty !== qty) {
                    this.updateOrderItemQty({
                        combination_key,
                        qty,
                        errCb: () => {
                            localCartItem.qty = item.qty;
                        }
                    })
                }
            })
        }, 500),
        cartItemAddOnQtyOnChange: _.debounce(function(qty) {
            this.localCartItems.forEach((localCartItem) => {
                const {combination_key, selected_add_ons} = localCartItem;
                const cartItem = this.cartItems.find(item => item.combination_key === combination_key);
                selected_add_ons.forEach((selected_add_on) => {
                    const {add_on_id, qty} = selected_add_on;
                    const add_on = cartItem.selected_add_ons.find(item => item.add_on_id === add_on_id);
                    if(add_on && add_on.qty !== qty) {
                        this.updateAddOnQty({
                            combination_key,
                            add_on_id,
                            qty,
                            errCb: () => {
                                selected_add_on.qty = add_on.qty;
                            }
                        });
                    }
                })
            })
        }, 500),
    }
}

export default cartItemListMixin;